/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_ParcelsInputs */

const vi_care_log_parcels = /** @type {(inputs: Care_Log_ParcelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vùng trồng`)
};

/**

* @param {Care_Log_ParcelsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_parcels = /** @type {((inputs?: Care_Log_ParcelsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_ParcelsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_parcels(inputs)
});